import { render, staticRenderFns } from "./MySQL.vue?vue&type=template&id=4fae8cec"
import script from "./MySQL.vue?vue&type=script&lang=js"
export * from "./MySQL.vue?vue&type=script&lang=js"
import style0 from "./MySQL.vue?vue&type=style&index=0&id=4fae8cec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports